import { getBrowserDetector } from 'qp-utility';
import { applicationConstants } from 'src/app/shared/applicationConstants';

// Background Service

//endpoint url
const default_host_url = 'sstv-cdf-feed-cdn.api.unow.firstlight.ai';
const default_endpoint_url = 'sstvfeed/in/4EiBL5eOSN.unow.json';

declare const tizen: any;

export const launchService = (serviceId) => {
  if (!tizen) {
    return;
  }
  if (getBrowserDetector().isTizen()) {
    tizen?.application.launchAppControl(
      // @ts-ignore
      new window.tizen.ApplicationControl('http://tizen.org/appcontrol/operation/pick', null, 'imag/jpeg', null, [
        // @ts-ignore
        new window.tizen.ApplicationControlData('caller', ['ForegroundApp']),
      ]),
      serviceId,
      function () {
        sendMessage();
      },
      function (e) {
        console.error('Launch failed: ' + e.message);
      }
    );
  }
};

function sendMessage() {
  // Message data is a dictionary - {key, value} pair, not just any Object
  const jsonText = '{"type": "https", "host": "' + default_host_url + '", "endpoint": "' + default_endpoint_url + '"}';
  const remotePort = tizen?.messageport.requestRemoteMessagePort(
    applicationConstants.TIZEN_BG_SERVICE_ID,
    applicationConstants.TIZEN_MSG_PORT_NAME
  );

  const messageData = {
    key: 'METADATA',
    value: jsonText,
  };

  try {
    console.log('sendMessage');
    remotePort.sendMessage([messageData]);
  } catch (e) {
    console.log('sendMessage error ' + e.message);
  }
}
